<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src='../../assets/snakes.gif' /></p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Add Snake Expert</h4>
            <form class="form-sample" @submit="onSubmit">
              <p class="card-description">
                <strong>Basic info</strong>
              </p>
              <p style="color:red;">{{error}}</p>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="User Name">
                    <b-form-input type="text" v-model="username" required=""></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input type="text" v-model="name" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
          <div class="row">
                          <div class="col-md-6">
                  <b-form-group horizontal label="Phone">
                    <b-form-input type="text" v-model="phone" required=""></b-form-input>
                  </b-form-group>
                </div>
                    <div class="col-md-6">
                       <b-form-group horizontal label="Password">
                   <b-form-input type="text" v-model="password" required=""></b-form-input>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Email">
                    <b-form-input type="email" v-model="email" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
                <hr>
                <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
export default {
  name: 'news',
  components: {
    VueEditor,
    Multiselect,
    vSelect
  },
  data () {
    return {
      username: '',
      name: '',
      password: '',
      phone: '',
      email: '',
      loading: false,
      error: ''
    }
  },
  methods: {
    resetForm () {
      this.username = ''
      this.name = ''
      this.password = ''
      this.phone = ''
      this.email = ''
      this.error = ''
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/user/',
        data: {
          name: this.name,
          username: this.username,
          phone: this.phone,
          email: this.email,
          password: this.password,
          is_expert: true,
          cpassword: this.password,
          is_rescue: 'false',
          lat: '20.5937',
          lon: '78.9629'
        },
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      })
        .then(response => {
          this.resetForm()
          alert('Successfully Added Snake Expert')
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.error = e.response.data.msg
          alert('Please try again')
        })
    }
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}
#preview img {
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/addexperts.vue